import { useSelector } from "react-redux";
import { RootState } from "../../../state/store";
import MyTeamCalendar from "../../Calendar/Team";
import MyEnquiries from "../../Enquiries/MyEnquiry";
import MyTeam from "../../Enquiries/MyTeam/index";
import QueueLists from "../../Enquiries/QueueLists/index";
import SearchResults from "../../Enquiries/SearchResults/Results";
function FirstCol() {
    const SiteInformation = useSelector((state: RootState) => state.SiteInformation);
    return (
        <>
            {SiteInformation.queuesListVisible && <QueueLists></QueueLists>}
            {SiteInformation.teamEnquiriesVisible && <MyTeam FullWidth={true}></MyTeam>}
            {SiteInformation.teamCalendarVisible && <MyTeamCalendar></MyTeamCalendar>}
            {SiteInformation.enquiriesListVisible && <MyEnquiries FullWidth={true}></MyEnquiries>}
            {SiteInformation.searchResultsVisible && <SearchResults FullWidth={true}></SearchResults>}
        </>
    );
}
export default FirstCol;
